/**
 *
 * Mixin
 *
 */

export const QaContainerMixin = {
  name: 'QaContainerMixin',

  components: {
    qa: () => import('@/components/QA/QA.vue'),
  },

  props: {
    qable: {
      type: Boolean,
      default: () => false,
    },
  },

  methods: {
    handleQaOpened() {
      //
    },
  },
};
